/*
 * @Description: 
 * @Author: zml
 * @Date: 2022-10-27 09:06:05
 * @LastEditors: xie
 * @LastEditTime: 2024-07-31 17:50:55
 */
import VueI18n from 'vue-i18n'
import Vue from 'vue'

//引入element的语言包
import enLocale from 'element-ui/lib/locale/lang/en.js' //英文
import zhLocale from 'element-ui/lib/locale/lang/zh-CN.js' //中文
import ruLocale from 'element-ui/lib/locale/lang/ru-RU.js' //俄语

// 引入需要语言包也可是js文件，export default抛出语言包的对象
import en from './lang/saas-en.js'
import zh from './lang/saas-zh-CN.js'
import ru from './lang/saas-ru-RU.js'

// 国安语言
import enLLH from './lang/LLH/saas-en.js'
import zhLLH from './lang/LLH/saas-zh-CN.js'
import esLLH from './lang/LLH/saas-es.js'

Vue.use(VueI18n)
let lang = localStorage.getItem('i18n') || 'en' || 'ru' || 'es'

export default new VueI18n({
    locale: lang,
    messages: {
        en: Object.assign(en, enLLH, enLocale),
        zh: Object.assign(zh, zhLLH, zhLocale),
        ru: Object.assign(ru, ruLocale), // 俄语
        es: Object.assign(esLLH), // 西班牙语
    }
})